import { IMedication } from '../../caremap/ICareMap';
import { CareMapState } from '../../caremap/CareMapState';
import { MixPanelEventEmitter } from '../../metrics/MixPanelEventEmitter';
import { StructuredRecordFormState } from '../structured-records/StructuredRecordFormState';
import { MedicationDescriptor } from './MedicationDescriptor';

export class MedicationFormState extends StructuredRecordFormState<IMedication> {
    static inject = () => [CareMapState, MixPanelEventEmitter, MedicationDescriptor];

    constructor(
        careMapState: CareMapState,
        mixpanel: MixPanelEventEmitter,
        protected descriptor: MedicationDescriptor
    ) {
        super(careMapState, mixpanel);
    }

    // Overrides the base's track(): medications additionally tag `Type` (photo vs. manual entry)
    // and, for photo-sourced adds, whether the user edited any OCR-extracted field before saving.
    // Neither prop applies to allergies/diagnoses, so the base track() doesn't build them -- this
    // class field shadows the base's (field initializers run in declaration order, so this one
    // overwrites the base's assignment once super() returns).
    track = (isAdd: boolean, isDelete?: boolean) => {
        const record = this.state.record;

        if (isDelete) {
            this.mixpanel.track(`${this.descriptor.trackingNoun} Removed`);
            return;
        }

        this.mixpanel.track(`${this.descriptor.trackingNoun} ${isAdd ? 'Added' : 'Edited'}`, () => ({
            ...(record ? this.descriptor.buildTrackingProps(record) : {}),
            'Type': this.state.usedPhoto ? 'photo' : 'manual',
            ...(isAdd && this.state.usedPhoto ? { 'User Changed': JSON.stringify(record) !== JSON.stringify(this.state.initialRecord) } : {})
        }));
    };
}
